import React from 'react';
import PageTitle from '../PageTitle';
import { Helmet } from 'react-helmet';

const Legal = () => {
  return (
    <>
      <Helmet>
        <title>I'm Your Huckleberry | Legal Disclaimer</title>
      </Helmet>
      <PageTitle title={'Legal Disclaimer'} />
      <div className="container py-5">
        <div className="disclaimer">
          <p>
            <strong>Disclaimer:</strong> I'm Your Huckleberry LLC strives to provide professional
            and high-quality cleaning services. However, by using our services, you acknowledge and
            agree to the following terms:
          </p>
          <ol>
            <li>
              <strong>Liability:</strong> I'm Your Huckleberry LLC is not liable for any damage to
              personal property, furniture, or items during the cleaning process unless caused by
              gross negligence or intentional misconduct by our staff. We recommend that all fragile
              or valuable items be removed or protected prior to the cleaning service.
            </li>
            <li>
              <strong>Allergens and Chemicals:</strong> While we use cleaning products that are safe
              for most environments, I'm Your Huckleberry LLC is not responsible for any allergic
              reactions, health issues, or damages caused by the cleaning products used, unless
              explicitly stated otherwise in our service agreement.
            </li>
            <li>
              <strong>Access to Property:</strong> The customer agrees to provide necessary access
              to all areas to be cleaned. If access is restricted, I'm Your Huckleberry LLC will not
              be responsible for areas not cleaned.
            </li>
            <li>
              <strong>Satisfaction Guarantee:</strong> While we aim for 100% customer satisfaction,
              I'm Your Huckleberry LLC does not guarantee that every stain, dirt mark, or
              imperfection can be removed. Cleaning results can vary based on the condition of
              surfaces, materials, and the length of time since cleaning.
            </li>
            <li>
              <strong>Cancellations and Rescheduling:</strong> Customers must provide at least 1
              week notice for cancellations or rescheduling. Failure to do so may result in a
              cancellation fee.
            </li>
          </ol>
          <p>
            By using our services, you agree to these terms and acknowledge that I'm Your
            Huckleberry LLC is not responsible for any unintended consequences outside of our
            control.
          </p>
        </div>
      </div>
    </>
  );
};

export default Legal;
